/**
 * Colours
 */
export const black = '#000'
export const white = '#FFF'

// Page background
export const page_background = '#3c687d'
export const page_text = '#fff'

// Connect and mint buttons
export const button_background = '#FFF'
export const button_text = '#3c687d'

// About section
export const about_background = '#FFF'
export const about_text = '#000'

// Roadmap section
export const roadmap_background = '#ed962c'
export const roadmap_text = '#000'

// Team section
export const team_background = '#3c687d'
export const team_text = '#FFF'
export const team_member_background = '#FFF'
export const team_member_text = '#000'

// FAQ section
export const faq_background = '#ed962c'
export const faq_title_text = '#000'
export const faq_question_background = '#FFF'
export const faq_question_text = '#000'

// Spinner colour
export const spinnerColour = '#FFF'

// Pop up theme ('light' or 'dark' mode)
export const TOAST_THEME = 'dark'

// Constants
export const off_black = 'rgba(0,0,0,0.25)'
export const off_white = 'rgba(255,255,255,0.85)'
export const text_shadow = '3px 3px 5px #00000044'
export const box_shadow = '0 0 10px 5px #00000022'

// Social
export const twitter_blue = '#1da1f2'
